// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"h4-z","dimensionLabel":"i4-z","styleChooserControlWrapper":"j4-z","styleChooserControl":"k4-z","disabled":"l4-z","giftCard":"m4-z","styleChooserText":"n4-z"};